export default {
    topics: [
        {
            title: ' GenerateLinkDimension ',
            href: 'sm-olapDimension-GenerateLinkDimension.html',
            attributes: { 'data-id': 'sm-olapDimension-GenerateLinkDimension' },
            menu: { hasChildren: false },
            tocID: 'sm-olapDimension-GenerateLinkDimension-d66e972',
            topics: [],
        },
        {
            title: ' GenerateSingleLevelDimension ',
            href: 'sm-olapDimension-GenerateSingleLevelDimension.html',
            attributes: { 'data-id': 'sm-olapDimension-GenerateSingleLevelDimension' },
            menu: { hasChildren: false },
            tocID: 'sm-olapDimension-GenerateSingleLevelDimension-d66e980',
            topics: [],
        },
        {
            title: ' GenerateTimeDimension ',
            href: 'sm-olapDimension-GenerateTimeDimension.html',
            attributes: { 'data-id': 'sm-olapDimension-GenerateTimeDimension' },
            menu: { hasChildren: false },
            tocID: 'sm-olapDimension-GenerateTimeDimension-d66e988',
            topics: [],
        },
        {
            title: ' InvalidAggregates ',
            href: 'sm-olapDimension-InvalidAggregates.html',
            attributes: { 'data-id': 'sm-olapDimension-InvalidAggregates' },
            menu: { hasChildren: false },
            tocID: 'sm-olapDimension-InvalidAggregates-d66e996',
            topics: [],
        },
        {
            title: ' UpdateLevelName ',
            href: 'sm-olapDimension-UpdateLevelName.html',
            attributes: { 'data-id': 'sm-olapDimension-UpdateLevelName' },
            menu: { hasChildren: false },
            tocID: 'sm-olapDimension-UpdateLevelName-d66e1004',
            topics: [],
        },
    ],
};

